import { render, staticRenderFns } from "./CustomersWeekly.vue?vue&type=template&id=31eb3d9c&scoped=true"
import script from "./CustomersWeekly.vue?vue&type=script&lang=js"
export * from "./CustomersWeekly.vue?vue&type=script&lang=js"
import style0 from "./CustomersWeekly.vue?vue&type=style&index=0&id=31eb3d9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb3d9c",
  null
  
)

export default component.exports